import toast from 'react-hot-toast';
import progressMagicJwtToken from '../../config/constants';
import { IChatMessage } from '../../redux/chat/chatSlice';
import i18n from '../../i18n';
import { toastStyles } from '../../utils/utils';

export default async function sendChatMessage({
  clientId,
  coachId,
  message,
  senderType,
  assetDuration,
  assetFile,
  chatMessageType,
}): Promise<IChatMessage> {
  const formData = new FormData();
  formData.append('clientId', clientId);
  formData.append('coachId', coachId);
  formData.append('message', message);
  formData.append('senderType', senderType);
  formData.append('assetDuration', assetDuration);
  formData.append('asset', assetFile);
  formData.append('chatMessageType', chatMessageType);
  const response = await fetch(`${process.env.REACT_APP_AUTH_SERVICE}/chat/sendMessage`, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(progressMagicJwtToken)}` || '',
    },
  });
  if (!response.ok) {
    if (response.status === 403) {
      toast.error(i18n.t('forbiddenResourceErrorMessage'), toastStyles.error);
      throw new Error(i18n.t('forbiddenResourceErrorMessage'));
    } else {
      toast.error(i18n.t('auth.toastMessage.unknownError'), toastStyles.error);
      throw new Error(i18n.t('auth.toastMessage.unknownError'));
    }
  }
  const data: IChatMessage = await response.json();
  return {
    id: data.id,
    chatId: data.chatId,
    message: data.message,
    messageType: data.messageType,
    senderType: data.senderType,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    assetDuration: data.assetDuration,
  };
}
